import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ButtonTemplate from '../ButtonTemplate';
import style from './styles/style.module.css';

class GradientButton extends PureComponent {
    render() {
        var props = { ...this.props };
        props.className = `${ this.props.className } ${ style.gradientButton }`.trim();
        props.labelClass = style.label;
        props.effectClass = style.effect;
        props.backgroundClass = style.backgroundColor;
        return (
            <ButtonTemplate { ...props } />
        );
    }
}
GradientButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
};
GradientButton.defaultProps = {
    label: '',
    className: '',
    onClick: () => {},
};

export default GradientButton;
